import currentDriverTypes from "./currentDriver.types";

export const fetchCurrentDriverStart = () => ({
  type: currentDriverTypes.FETCH_CURRENTDRIVER_START,
});

export const fetchCurrentDriverSuccess = (data) => {
  return {
    type: currentDriverTypes.FETCH_CURRENTDRIVER_SUCCESS,
    payload: data,
  };
};

// async
let currentDriver_counter = 0;
export const fetchCurrentDriverAsync = (socket, load_id) => (dispatch) => {
  dispatch(fetchCurrentDriverStart());

  socket.emit("get_driver_private_info", {
    load_id,
  });

  if (currentDriver_counter++ !== 0) return;
  socket.on("response_driver_private_info", (data) => {
    console.log(data);
    // alert("data");

    dispatch(fetchCurrentDriverSuccess(data[0]));
    // LOADS_STATE.currentCardDriver = data;
    // console.log(LOADS_STATE.currentCardDriver);
    // document.querySelector(
    //   "#callDriver-btn"
    // ).href = `tel:${LOADS_STATE.currentCardDriver[0].mobile}`;
  });
};
